var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 11.1406C13.3672 11.6094 13.3672 12.4297 12.8594 12.8984C12.625 13.1328 12.3125 13.25 12 13.25C11.6484 13.25 11.3359 13.1328 11.1016 12.8984L7 8.79688L2.85938 12.8984C2.625 13.1328 2.3125 13.25 2 13.25C1.64844 13.25 1.33594 13.1328 1.10156 12.8984C0.59375 12.4297 0.59375 11.6094 1.10156 11.1406L5.20312 7L1.10156 2.89844C0.59375 2.42969 0.59375 1.60938 1.10156 1.14062C1.57031 0.632812 2.39062 0.632812 2.85938 1.14062L7 5.24219L11.1016 1.14062C11.5703 0.632812 12.3906 0.632812 12.8594 1.14062C13.3672 1.60938 13.3672 2.42969 12.8594 2.89844L8.75781 7.03906L12.8594 11.1406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseHeader);
export default __webpack_public_path__ + "static/media/icon_close_header.9b2054badff3cb43da89ada4b0c053ed.svg";
export { ForwardRef as ReactComponent };